import 'aws-amplify/auth/enable-oauth-listener';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';

@Component({
    selector: 'app-auth-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    standalone: false
})
export class CallbackComponent implements OnInit {
  statusMessage = 'Completing sign-in…';
  errorMessage = '';

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly mixpanelService: MixpanelService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      const params = this.route.snapshot.queryParamMap;
      const oauthError = params.get('error_description') || params.get('error');
      if (oauthError) {
        throw new Error(oauthError);
      }

      // Amplify exchanges ?code=&state= for tokens (requires enable-oauth-listener above).
      const { username } = await this.authService.establishSessionFromAmplify();

      this.mixpanelService.setIdentity(username);
      this.mixpanelService.register({ session_id: new Date().getTime() });
      this.mixpanelService.track('Login');

      this.statusMessage = 'Sign-in successful. Redirecting…';
      // Hard navigation so Home reloads with a complete session (avoids blank
      // screen when Okta SSO returns quickly for an already-signed-in IdP session).
      window.location.assign('/home?l=1');
    } catch (err: any) {
      console.error('SSO callback failed:', err);
      this.errorMessage =
        err?.message ||
        'SSO sign-in failed. Please try again or use email/password login.';
      this.statusMessage = '';
      setTimeout(() => {
        this.router.navigate(['/'], {
          queryParams: { ssoError: '1' },
        });
      }, 2500);
    }
  }
}
